// Single source of truth for "take the user to the pricing section".
//
// The pricing section lives only on the Home landing. A signed-in user who
// asks for pricing must carry the ?pricing=1 intent so the router guard lets
// them land on Home instead of bouncing to the dashboard (see
// router/pricingIntent.js + the beforeEach guard). Every entry point — the
// desktop account rail, the mobile drawer, the post-signup return — must use
// this so none of them regress to a bare "/" navigation.
export function navigateToPricing(router) {
  if (router.currentRoute.value.path !== '/') {
    router.push({ path: '/', query: { pricing: '1' } });
    // PricingSection scrolls to #pricing when it sees the intent; this is a
    // belt-and-suspenders scroll for the case where it is already mounted.
    setTimeout(() => {
      document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  } else {
    document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' });
  }
}
